module.exports = __webpack_public_path__ + "img/um.a9474aff.svg";